import React from 'react'
import { View, Image, Text, ViewPropTypes } from 'react-native'
import { map as _map } from 'lodash'
import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components'
import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes'
import PropTypes from 'prop-types'

import styles from './AddOnsExtraData.styles'

function AddOnsExtraData({
  isExpanded,
  showMoreData,
  showMoreDataStyles,
  images,
  theme = LightThemeColors,
}) {
  const { container, rowContainer, icon, iconSize, label, amount, unit } =
    showMoreDataStyles || {}
  if (!isExpanded) {
    return null
  }
  return (
    <View style={[styles.moreDataContainer(showMoreData || []), container]}>
      {_map(showMoreData, (item, index) => (
        <View
          style={[
            styles.moreDataRowContainer(index, showMoreData.length, theme),
            rowContainer,
          ]}
        >
          <View style={styles.showMoreDataLeftItem}>
            <Icon
              name={images[item.icon]}
              type="image"
              style={icon}
              size={iconSize || 25}
            />
            <VFText i18nKey={item.label} style={[styles.label, label]} />
          </View>
          <Text style={styles.showMoreDataRightItem}>
            <VFText i18nKey={item.amount} style={[styles.amount, amount]} />
            {Boolean(item.unit) && <VFText i18nKey={' ' + item.unit} style={[styles.unit, unit]} />}
          </Text>
        </View>
      ))}
    </View>
  )
}

AddOnsExtraData.propTypes = {
  isExpanded: PropTypes.bool,
  showMoreData: PropTypes.arrayOf([
    PropTypes.objectOf({
      icon: PropTypes.string,
      label: PropTypes.string,
      amount: PropTypes.number,
      unit: PropTypes.string,
    }),
  ]),
  showMoreDataStyles: PropTypes.objectOf({
    icon: Image.propTypes.style,
    iconSize: PropTypes.number,
    label: Text.propTypes.style,
    amount: Text.propTypes.style,
    unit: Text.propTypes.style,
    container: ViewPropTypes.style,
    rowContainer: ViewPropTypes.style,
  }),
  images: PropTypes.object,
  theme: PropTypes.objectOf({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
}

export default AddOnsExtraData
